import { Component, Inject, OnInit } from '@angular/core';
import { WINDOW } from '@upr-web-primer/window';
import { CommonUtilityService } from '../../services/common-utility.service';

@Component({
  selector: 'app-signin',
  template: '',
  styles: [],
})
export class SigninComponent implements OnInit {
  constructor(
    private common: CommonUtilityService,
    @Inject(WINDOW) private window: any
  ) {}

  ngOnInit(): void {
    this.common.invokeFireEvent(
      'Link | Sign In',
      'Internal Link',
      'Click',
      'null',
      new Date().toISOString(),
      'evar202',
      '',
      this.window?.digitalData?.page?.category?.primaryCategory,
      this.window?.digitalData?.page?.category?.subCategory1
    );
    /** TO DO Category values should be mapped once page type configured */
    this.common.invokeFireEvent(
      'accountLogin',
      'Success',
      'Form',
      '',
      new Date().toISOString(),
      localStorage.getItem('OAUTH_LOGIN_GID') || '',
      '',
      this.window?.digitalData?.page?.category?.primaryCategory,
      this.window?.digitalData?.page?.category?.subCategory1
    );
    const redirectUrl = this.common.getOidcRedirectionUrl();
    this.common.redirectToOidcApp(redirectUrl);
  }
}
